import { createContext, useContext } from 'react';
import type ERDFlowStore from '../../store/ERDFlowStore';

export const ERDFlowContext = createContext<ERDFlowStore | null>(null);

export const useERDFlowContext = () => {
	const store = useContext(ERDFlowContext);
	if (!store) {
		throw new Error('useERDFlowContext must be used within a ERDFlowProvider');
	}
	return store;
};
